import { Injectable } from '@angular/core';
import { WhatsappIntegration } from '../../../interfaces/common/whatsappIntegration';
import { Observable } from 'rxjs';
import { WhatsappIntegrationApi } from '../api/whatsappIntegration.api';
import { MailIntegration } from '../../../interfaces/common/mailIntegration';
import { MailIntegrationApi } from '../api/mailIntegration.api';

@Injectable({
    providedIn: 'root'
})
export class MailIntegrationService extends MailIntegration {
    constructor(private api: MailIntegrationApi) {
        super();
    }

    sendMailMessage(data: any): Observable<any> {
        return this.api.dynamicMailPost(data);
    }



}